import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';
import { EventsHttpModel } from '../../models/event.model';

import { AgentData, AgentDataApi } from '../../models/phone-agent.model';

import { map } from 'rxjs/operators';

@Injectable()
export class AskStateService {
  private updateEvents = new Subject<boolean>();

  constructor(private commonService: CommonService) {}

  getEvents(): Observable<EventsHttpModel> {
    const url = `${environment.apiBase}/mortgages-events/${environment.api_version.events}/events`;
    return this.commonService.getVerb(url, false).pipe(
      map((response: EventsHttpModel) => {
        if (response.stateUx && response.stateUx.toString().indexOf('.') < 0) {
          response.stateUx = response.stateUx;
        }
        return response;
      }),
    );
  }

  getUpdateEvents(): Observable<any> {
    return this.updateEvents.asObservable();
  }

  getPhoneAgent(): Observable<AgentData> {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/agent`;
    return this.commonService.getVerb(url).pipe(
      map((data: AgentDataApi) => {
        return data.agent;
      }),
    );
  }

  onUpdateEvents() {
    this.updateEvents.next(true);
  }
}
